export class BlockExplorer {
    rpcUrls;
    constructor(rpcUrls) {
        this.rpcUrls = rpcUrls;
    }
    async getLinkForNetwork(network) {
        return this.rpcUrls[network.type];
    }
}
//# sourceMappingURL=block-explorer.js.map